import { useMutation, useQueryClient } from '@tanstack/react-query'
import { goLive } from '@/api/live'
import { refreshAfterWrite } from '@/lib/refreshAfterWrite'

// Frontend PRD 11 - deliberately narrower refresh than publish's (see the
// 'go-live' row in lib/refreshAfterWrite.ts): repointing changes which
// published bundle is live, it never touches the draft, so the
// draft-related keys are left alone.
export function useGoLiveMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (version?: string) => goLive(version),
    onSuccess: () => refreshAfterWrite(queryClient, { kind: 'go-live' }),
  })
}
